import { IObservableArray, makeAutoObservable, observable } from "mobx";
import { TagResponseApi } from "../DTO/ServerResponseType/Tag/Tag";
import TagServerClient from "../ServerClients/TagServerClient";

export class TagsStore {
  public tags: IObservableArray<TagResponseApi> = observable.array([]);
  public addedTagName: string = "";
  public showManageTags: boolean = false;

  deletedTagId: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  public onManageModalOpen = () => {
    this.showManageTags = true;
    this.deletedTagId = "";
  };

  public onManageModalClose = () => {
    this.showManageTags = false;
  };

  public addTagAsync = async () => {
    return TagServerClient.sendToCreateTagAsync(this.addedTagName)
      .then((tagId: string) => {
        this.tags.push({ tagId: tagId, tagName: this.addedTagName });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  public deleteTagAsync = async () => {
    return TagServerClient.sendToDeleteTagAsync(this.deletedTagId).then(() => {
      this.tags.replace(
        this.tags.filter(
          (tag: TagResponseApi) => tag.tagId !== this.deletedTagId
        )
      );
    });
  };

  onChangeDeletedTagId = (event: React.FormEvent<HTMLSelectElement>) => {
    let eventOption =
      event.currentTarget.options[event.currentTarget.selectedIndex];

    if (eventOption) this.deletedTagId = eventOption.value;
  };

  onChangeNewTagName = (event: React.FormEvent<HTMLInputElement>) => {
    this.addedTagName = event.currentTarget.value;
  };

  setTags = (tags: TagResponseApi[]) => {
    this.tags.replace(tags);
  };
}
